module.exports = __webpack_public_path__ + "static/media/DC_O_Timeless_Sforza_DKGold.66cebafa.png";